import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AccountDto } from '@dto';
import { GenericOldService } from './generic-old.service';

@Injectable({ providedIn: 'root' })
export class AccountService {
  private readonly accountEmitter = new Subject<AccountDto[]>();

  apiUrl: string;

  constructor(private resourceService: GenericOldService<AccountDto>) {
    this.apiUrl = resourceService.apiLocation;
  }

  getAccounts$(developerId: number | string): Observable<AccountDto[]> {
    return this.resourceService.getList(`developers/${developerId}/accounts`);
  }

  getAllAccounts$(): Observable<AccountDto[]> {
    return this.resourceService.getList(`types/account`).pipe(
      tap(accounts => {
        this.accountEmitter.next(accounts);
      }),
    );
  }

  getAccount$(accountId: number | string): Observable<AccountDto> {
    return this.resourceService.getById('accounts', accountId);
  }
}
